import { FormattedAlert } from "screens/alerts/utils";
import { Color } from "utils/theme";

interface AlertDetailsProps {
  alert: FormattedAlert;
}

export const AlertDetails = ({ alert }: AlertDetailsProps) => {
  return (
    <div className="px-4 md:pl-16 pb-6 max-w-md space-y-2">
      <div className="w-full flex justify-between">
        <p className="text-sm flex-1" style={{ color: Color.Primary[400] }}>
          Coordinates
        </p>
        <p className="text-sm flex-1">{alert.coordinates}</p>
      </div>
      <div className="w-full flex justify-between">
        <p className="text-sm flex-1" style={{ color: Color.Primary[400] }}>
          Trigger Time
        </p>
        <p className="text-sm flex-1">{alert.triggerTime}</p>
      </div>
      {alert.sources.length > 0 && (
        <div className="w-full flex justify-between">
          <p className="text-sm  flex-1" style={{ color: Color.Primary[400] }}>
            Devices
          </p>
          <div className="flex items-center space-x-2 flex-1">
            {alert.sources.map((source, index) => (
              <p key={index} className="text-sm">
                {source}
              </p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
